import * as React from 'react';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';

import { UitkStepInput } from 'uitk-react-step-input';

import { FlightsTravelerType } from '__generated__/api';
import { TravelerOptionItem } from 'types/search/wizard';
import { trackAnalytics } from 'utility';
import { AnalyticsStore } from 'bernie-core';
import { AnalyticsType } from 'types/shared';

export interface TravelerInputsProps {
  travelerOptionItem: TravelerOptionItem;
  analytics: AnalyticsStore;
  changeAnalytics: AnalyticsType;
}

export const TravelerInputs = observer(({ travelerOptionItem, analytics, changeAnalytics }: TravelerInputsProps) => {
  const {
    label,
    caption,
    max,
    minCount,
    type,
    travelerCount,
    increaseCountAccessibility,
    decreaseCountAccessibility,
    increaseCountAnalytics,
    decreaseCountAnalytics
  } = travelerOptionItem;

  const increaseAgeInputs = () => {
    if (!travelerOptionItem.travelerAges) {
      travelerOptionItem.travelerAges = [];
    }
    const templateClone = toJS(travelerOptionItem.travelerAgeSelectorTemplate);
    travelerOptionItem.travelerAges.push(templateClone);
    trackAnalytics(increaseCountAnalytics, analytics);
  };

  const decreaseAgeInputs = () => {
    travelerOptionItem.travelerAges.pop();
    trackAnalytics(decreaseCountAnalytics, analytics);
  };

  const modifyAgeInputs = (previousCount: number, currentCount: number) => {
    const countIncreased = previousCount < currentCount;
    const countDecreased = previousCount > currentCount;

    if (countDecreased) {
      decreaseAgeInputs();
    } else if (countIncreased) {
      increaseAgeInputs();
    }
  };

  const onInputChange = (event: React.ChangeEvent) => {
    const target = event.target as HTMLInputElement;
    const value = parseInt(target.value, 10);
    const previousValue = travelerOptionItem.travelerCount;

    if (!isNaN(value)) {
      travelerOptionItem.travelerCount = value;
    }

    if (type !== FlightsTravelerType.ADULT) {
      modifyAgeInputs(previousValue, travelerOptionItem.travelerCount);
    }

    if (type === FlightsTravelerType.ADULT) {
      const countIncreased = previousValue < travelerOptionItem.travelerCount;
      const countDecreased = previousValue > travelerOptionItem.travelerCount;
      countIncreased && trackAnalytics(increaseCountAnalytics, analytics);
      countDecreased && trackAnalytics(decreaseCountAnalytics, analytics);
    }
    trackAnalytics(changeAnalytics, analytics);
  };

  return (
    <UitkStepInput
      title={label}
      decreaseText={decreaseCountAccessibility}
      increaseText={increaseCountAccessibility}
      caption={caption}
      max={max}
      min={minCount}
      value={travelerCount}
      onChange={onInputChange}
    />
  );
});
